import { Box } from '@mui/material';

import type { BoxProps } from '@mui/material';
import type { FC, HTMLProps } from 'react';

export interface SectionProps extends BoxProps<'section'> {
  id: string;
}

export const Section: FC<SectionProps> = ({ id, children, ...props }) => (
  <Box component="section" id={id} {...props}>
    {children}
  </Box>
);
